import { textStyle } from '@/components/ui/Typography/Body/Text/style';
import { tv } from '@/utils/libs/tailwind-variants';
/**
 * HotlineClientStopOfferModal のスタイル
 */
export const hotlineClientStopOfferModalStyle = tv({
    slots: {
        base: ['!max-w-[min(527px,100%)]'],
        button: ['sm:max-[200px]'],
        buttonWrap: ['flex flex-col sm:flex-row-reverse justify-center gap-16'],
        contentWrap: ['flex flex-col gap-20 md:gap-28'],
        descriptionContent: ['flex flex-col item-center gap-8'],
        descriptionTitle: [textStyle({ color: 'base', isBold: true, size: 'sm' })],
        textContent: [
            textStyle({ color: 'base', size: 'md' }),
            'whitespace-pre-line break-words',
            'mt-8',
        ],
        warningPointContent: [
            textStyle({ color: 'base', size: 'sm' }),
            'w-full',
            'p-16',
            'rounded-md',
            'bg-orange-50',
        ],
    },
});
